(() => {
  const THRESHOLD = 10000;
  const GRAMS_PER_STEP = 50;
  const MAX_STEPS = 20;
  const GIFT_PRODUCT_ID = 15526124978551;
  const MYSTERY_GIFT_PRODUCT_ID = 14890000417143;
  const VARIANTS = {
    1: 57359789916535, 2: 57359789949303, 3: 57359789982071, 4: 57359790014839,
    5: 57359790047607, 6: 57359790080375, 7: 57359790113143, 8: 57359790145911,
    9: 57359790178679, 10: 57359790211447, 11: 57359790244215, 12: 57359790276983,
    13: 57359790309751, 14: 57359790342519, 15: 57359790375287, 16: 57359790408055,
    17: 57359790440823, 18: 57359790473591, 19: 57359790506359, 20: 57359790539127
  };
  const ATTRIBUTE = 'Cadeau Cannabise';
  let running = false;
  let rerun = false;
  let internalRequest = false;
  let timer;

  const isTieredGift = (item) =>
    Number(item.product_id) === GIFT_PRODUCT_ID ||
    item.properties?._tiered_gift === 'true';

  const isMysteryGift = (item) =>
    Number(item.product_id) === MYSTERY_GIFT_PRODUCT_ID;

  const isGift = (item) => isTieredGift(item) || isMysteryGift(item);

  const sectionIds = () => {
    const drawer = document.querySelector('cart-drawer[data-section-id]');
    return [drawer?.dataset.sectionId].filter(Boolean);
  };

  async function request(url, options = {}) {
    internalRequest = true;
    try {
      return await window.fetch(url, options);
    } finally {
      internalRequest = false;
    }
  }

  async function cartJson() {
    const response = await request('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Impossible de lire le panier');
    return response.json();
  }

  function decorate(grams = null) {
    document.querySelectorAll('[data-is-gift="true"]').forEach((line) => {
      const list = line.parentElement;
      if (list && list.firstElementChild !== line) list.prepend(line);
      line.setAttribute('aria-label', grams ? `Cadeau : ${grams} g de CBD offerts` : 'Cadeau CBD');
    });

    const drawer = document.querySelector('cart-drawer');
    const items = drawer?.querySelector('.cart-drawer__items');
    let message = drawer?.querySelector('[data-tiered-gift-congrats]');
    if (!items || !grams) {
      message?.remove();
      return;
    }
    if (!message) {
      message = document.createElement('div');
      message.dataset.tieredGiftCongrats = '';
      message.setAttribute('role', 'status');
      items.before(message);
      requestAnimationFrame(() => message.classList.add('is-visible'));
    }
    const text = `🎉 Félicitations ! ${grams} g de CBD offerts`;
    if (message.textContent !== text) message.textContent = text;
  }

  async function render(state) {
    const drawer = document.querySelector('cart-drawer');
    if (state?.sections && drawer?.renderCartContents) {
      await drawer.renderCartContents({
        sections: state.sections,
        itemCount: state.item_count
      });
    }
    const cart = await cartJson();
    const eligible = Math.max(0, Number(cart.total_price) || 0);
    decorate(Math.min(MAX_STEPS, Math.floor(eligible / THRESHOLD)) * GRAMS_PER_STEP || null);
  }

  async function reconcile() {
    const cart = await cartJson();
    const eligibleSubtotal = Math.max(0, Number(cart.total_price) || 0);
    const steps = Math.min(MAX_STEPS, Math.floor(eligibleSubtotal / THRESHOLD));
    const grams = steps * GRAMS_PER_STEP;
    const targetVariant = VARIANTS[steps];
    const gifts = cart.items.filter(isTieredGift);
    const correct = gifts.find(
      (item) => Number(item.variant_id) === targetVariant && item.quantity === 1
    );
    const updates = {};
    gifts.forEach((item) => {
      if (!correct || item.key !== correct.key) updates[item.key] = 0;
    });
    if (correct && correct.quantity !== 1) updates[correct.key] = 1;

    const mysteryGifts = cart.items.filter(isMysteryGift);
    mysteryGifts.forEach((item, index) => {
      if (index > 0) updates[item.key] = 0;
      else if (item.quantity !== 1) updates[item.key] = 1;
    });

    const ids = sectionIds();
    let state = null;
    const attributes = { [ATTRIBUTE]: grams ? `${grams} g de CBD offerts` : '' };

    if (Object.keys(updates).length || cart.attributes?.[ATTRIBUTE] !== attributes[ATTRIBUTE]) {
      const response = await request('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          attributes,
          sections: ids.join(','),
          sections_url: window.location.pathname
        })
      });
      state = await response.json();
    }

    if (steps > 0 && !correct) {
      const title = `${grams} g de CBD offerts 🎁`;
      const response = await request('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: targetVariant,
            quantity: 1,
            properties: {
              _is_gift: 'true',
              _tiered_gift: 'true',
              _gift_title: title,
              _gift_badge: `Cadeau Cannabise : ${grams} g offerts`,
              _gift_grams: String(grams)
            }
          }],
          sections: ids.join(','),
          sections_url: window.location.pathname
        })
      });
      state = await response.json();
    }

    if (state?.sections) await render(state);
    else decorate(grams || null);
  }

  async function sync() {
    if (running) {
      rerun = true;
      return;
    }
    running = true;
    try {
      do {
        rerun = false;
        await reconcile();
      } while (rerun);
    } catch (error) {
      console.error('[Système cadeau Cannabise]', error);
    } finally {
      running = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 20);
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = String(args[0]?.url || args[0] || '');
    if (!internalRequest && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) schedule();
    return response;
  };

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:update', schedule);
  document.addEventListener('DOMContentLoaded', sync, { once: true });
  if (document.readyState !== 'loading') sync();

})();